import PlayIcon from "@assets/icons/play.svg";
import { Exercise } from "@domain/exercise/exercise";
import styled from "@emotion/styled";
import { BodyPartIcon } from "@ui/components/exercise/body-part-icon";
import { colors } from "@ui/style/colors";
import { absoluteFillObject } from "@ui/style/layout";
import React from "react";

interface MobileLibraryExerciseCardProps {
	exercise: Exercise;
	onThumbnailClick: () => void;
	onSelect: () => void;
	selected?: boolean;
	disabled?: boolean;
}

export const MobileLibraryExerciseCard = ({
	exercise,
	onSelect,
	selected = false,
	onThumbnailClick,
	disabled = false,
}: MobileLibraryExerciseCardProps): JSX.Element => (
	<Container selected={selected} onClick={onSelect}>
		<ThumbnailContainer>
			<Thumbnail
				onClick={e => {
					e.stopPropagation();
					onThumbnailClick();
				}}
				src={exercise.thumbnails.mediumThumbnailUrl}
			/>
			<PlayIconCircle>
				<PlayIcon color={colors.white} />
			</PlayIconCircle>
		</ThumbnailContainer>
		<ExerciseTitle className="p-size-s-rubik-medium">{exercise.title}</ExerciseTitle>
		<BodyPartIcon
			bodyPart={exercise.primaryBodyPart}
			additionalBodyPartsCount={exercise.secondaryBodyParts.length}
			width={24}
			height={24}
			style={{ filter: disabled ? "grayscale(1)" : "" }}
		/>
		{disabled && <Overlay />}
	</Container>
);

const PlayIconCircle = styled.div`
	width: 24px;
	height: 24px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 12px;
	display: grid;
	place-content: center;
	padding-left: 3px;
	pointer-events: none;
	touch-action: none;
`;

const ThumbnailContainer = styled.div`
	display: grid;
	place-items: center;

	> * {
		grid-column: 1;
		grid-row: 1;
	}
`;

const Container = styled.div<{ selected: boolean }>`
	position: relative;
	display: flex;
	border-radius: 8px;
	padding: 8px;
	padding-right: 12px;
	border: 1px solid ${colors.primary10};
	border-color: ${({ selected }) => (selected ? colors.primary : colors.primary10)};
	gap: 8px;
	align-items: center;
`;

const Thumbnail = styled.img`
	cursor: pointer;
	height: 64px;
	width: 64px;
	object-fit: cover;
	border-radius: 2px;
	flex: 0;
`;

const ExerciseTitle = styled.div`
	flex-grow: 1;
`;

const Overlay = styled.div`
	${absoluteFillObject}
	background-color: ${colors.grey5};
	opacity: 0.4;
`;
